import { appMixin } from '../utils/appMixin';
import { BREAKPOINTS } from '../utils/config';
import { EVENTS } from '../utils/constants';

export class Viewport extends appMixin() {
  constructor(app) {
    super(app);
    this._autoResize = this.app.params.autoResize;

    this.resize();
    const bbox = app.$parent.getBoundingClientRect();
    this.sizeManuallySet = false;

    this.width = bbox.width;
    this.height = bbox.width;

    this.dpr = window.innerWidth < BREAKPOINTS.tablet ? 2 : 1.5;
    this.ratio = bbox.width / bbox.height;
    this.device =
      window.innerWidth < BREAKPOINTS.tablet
        ? 'mobile'
        : window.innerWidth < BREAKPOINTS.desktop
        ? 'tablet'
        : 'desktop';
    this.scrollSize = this.app.$parent.getBoundingClientRect().height - this.height;
    this.isTouch =
      'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  get autoResize() {
    return this._autoResize;
  }

  set autoResize(value) {
    this._autoResize = value;
    if (value) this.resize();
  }

  onAttach() {
    this._isAttached = true;

    if (this.autoResize) {
      const resizeObserver = new ResizeObserver(this.resize);
      resizeObserver.observe(this.app.$parent);
    }
    if (!this.sizeManuallySet) this.resize();
  }

  get infos() {
    return {
      width: this.width,
      height: this.height,
      dpr: this.dpr,
      ratio: this.ratio,
      device: this.device,
    };
  }

  _onResize = () => {
    if (this.rto) clearTimeout(this.rto);
    this.rto = setTimeout(this.resize, 500);
  };

  resize = () => {
    if (!this._isAttached) return;
    this.app.webgl.renderer.domElement.style.position = 'absolute';
    const bbox = this.app.$parent.getBoundingClientRect();
    this.setSize(bbox.width, bbox.height);
  };

  setSize(width, height) {
    this.sizeManuallySet = true;

    this.width = width;
    this.height = height;

    this.app.webgl.renderer.domElement.style.width = `${width}px`;
    this.app.webgl.renderer.domElement.style.height = `${height}px`;

    // console.log(width, height)
    this.app.webgl.renderer.setSize(width, height, true);

    this.dpr = window.innerWidth < BREAKPOINTS.tablet ? 2 : 1.5;
    this.ratio = width / height;
    this.device =
      window.innerWidth < BREAKPOINTS.tablet
        ? 'mobile'
        : window.innerWidth < BREAKPOINTS.desktop
        ? 'tablet'
        : 'desktop';

    this.emit(EVENTS.RESIZE, this.infos);
  }
}
